import { useEffect, useRef } from "react";
import { useNavigate } from "react-router";

import { KlarnaApi } from "../api/KlarnaApi";

import "../assets/scss/components/_klarna.scss";

let klarnaInitialized = false;

export const Klarna = () => {
	const container = useRef(null);
	const navigate = useNavigate();

	const LoadKlarna = async () => {
		if (klarnaInitialized) return;
		klarnaInitialized = true;

		try {
			const clientToken = await KlarnaApi.getClientToken();
			if (!clientToken) {
				return;
			}
			window.Klarna.Payments.Buttons.init({
				client_token: clientToken,
			}).load({
				container: container.current,
				theme: "default",
				shape: "default",
				locale: "en-GB",
				on_click: (authorize) => {
					authorize(
						{
							auto_finalize: true,
							collect_shipping_address: false,
						},
						null,
						async (result) => {
							if (result.approved === true) {
								const createOrder = await KlarnaApi.finalizeOrder(result.authorization_token);
								if (createOrder?.payment?.redirect_url) {
									// Order creation was successful, redirect to the payment success page
									// Use replace so they can't go back to the payment page
									navigate(createOrder?.payment?.redirect_url, { replace: true });
								} else {
									// Payment was successful but order creation failed, show failure
								}
							} else {
								// Do nothing, payment was not approved
								// This is generally called when the user cancels the payment
								// Since it's a popup we don't need to do anything
							}
						},
					);
				},
			});
		} catch (err) {
			console.error(err);
		}
	};

	useEffect(() => {
		const script = document.createElement("script");
		script.src = "https://x.klarnacdn.net/kp/lib/v1/api.js";
		script.async = true;
		document.body.appendChild(script);
		window.klarnaAsyncCallback = LoadKlarna;

		return () => {
			document.body.removeChild(script);
			delete window.klarnaAsyncCallback;
			klarnaInitialized = false;
			if (window.Klarna) {
				delete window.Klarna;
			}
		};
	}, []);

	return (
		<>
			<div id="klarna-payments-container" className="payments-container" ref={container} />
		</>
	);
};

export default Klarna;
